
export const AIAdminConstant = {
    keyAreas: {
        processDocument: 'key_areas/process_template/?key_area_id=',
        get: 'key_areas/get_key_areas/',
        create: 'key_areas/create_key_area/',
        delete: 'key_areas/delete_key_area/',
        update: 'key_areas/update_key_area/',
        get_template: 'key_areas/get_templates_keyarea/',
        update_template: 'key_areas/update_template/',
        create_context: 'v2/admin/context-template/',
        get_context: 'v2/admin/context-templates/',
        delete_context: 'v2/admin/delete-context-template/',
        update_context: 'v2/admin/update-context-templates-is-active/',
        download_blob: 'v2/user/download?blob_url=',
        getContextID: 'v2/admin/get-assessments-by-context/',
        deleteFileChunks: 'v2/user/delete-file-chunks/',
        generate_questionnaire: 'v2/client/generate-questionnaire/',
        Listofquuestionaries: 'v2/questionnaire/list-of-questionnaires_by_mig_id/',
        downloadquestionnaries: 'v2/questionnaire/download/',
        updtaequestionariesstatus: 'v2/questionnaire/update-questionnaire-status/',
        deletequestionary: 'v2/questionnaire/delete/',
        downloadAdminTemplate: 'v2/admin/download-admin-template?mig_id=',
        uploadQuestionary: 'v2/questionnaire/upload-questionnaire/'
    },
    scenario: {
        update: 'migscenorios/update_mig_scenorio/',
        delete: 'migscenorios/delete_mig_scenorio/',
        getMigMapping: 'migscenorios/get_mig_mappings/{mig_id}/?mig_scenario_id='
    },
    teams: {
        create_group_chat: 'teams/create-group-chat',
        add_members: 'teams/add-members',
        delete_group_chat: 'teams/delete-group-chat',
    }
}